import replaceDomain from '@/utils/replaceDomain';

export const APP_PLATFORM = process.env.VUE_APP_PLATFORM;
export const APP_VERSION = process.env.VUE_APP_VERSION;

export const APP_UK_ADMIN = process.env.VUE_APP_UK_ADMIN;
export const APP_US_ADMIN = process.env.VUE_APP_US_ADMIN;
export const APP_US_PAY = process.env.VUE_APP_US_PAY;

export const APP_PAY_URL = replaceDomain(
  process.env.VUE_APP_PAY_URL,
  APP_US_ADMIN,
  APP_US_PAY,
);

export const APP_NEW_BRIDGE = replaceDomain(
  process.env.VUE_APP_NEW_BRIDGE,
  APP_US_ADMIN,
  APP_US_ADMIN,
);

export const APP_NEW_IFRAME = process.env.VUE_APP_NEW_IFRAME;
